<template>
  <div
    :class="
      $cn([
        'flex rounded-md ring-1 ring-inset ring-input focus-within:ring-primary focus-within:hover:ring-primary',
        {
          'bg-gray-50 text-paragraph/50': disabled || pending,
          'ring-red-500': errors,
          'hover:ring-input-hover': !errors
        },
        ui?.base
      ])
    "
  >
    <input
      v-if="!textarea"
      :id="name"
      type="text"
      :name="name"
      v-bind="$attrs"
      :value="modelValue"
      :class="
        $cn([
          'form-input grow border-none bg-transparent px-4 py-3 text-sm focus:outline-none focus:ring-0',
          { 'cursor-not-allowed': disabled || pending },
          ui?.input
        ])
      "
      :disabled="disabled"
      @input="emit('update:modelValue', $event.target.value)"
      @blur="onBlur"
    />
    <textarea
      v-else
      :id="name"
      :name="name"
      :class="
        $cn([
          'file-textarea grow border-none bg-transparent px-4 py-3 text-sm focus:outline-none focus:ring-0',
          { 'cursor-not-allowed': disabled || pending },
          ui?.input
        ])
      "
      rows="3"
      v-bind="$attrs"
      :disabled="disabled"
      @input="emit('update:modelValue', $event.target.value)"
      @blur="onBlur"
    >{{ modelValue }}</textarea>
  </div>
</template>

<script setup lang="ts">
import type { ClassValue } from 'clsx'

const props = withDefaults(
  defineProps<{
    modelValue: string | null
    name: string
    disabled?: boolean
    textarea?: boolean
    ui?: Partial<{
      base: ClassValue
      input: ClassValue
    }>
  }>(),
  {
    disabled: false,
    textarea: false,
    ui: undefined
  }
)

const emit = defineEmits(['update:modelValue'])
const { autosave, pending, getFieldErrors, submit } = injectStrict<ProvideForm>('form')
const errors = getFieldErrors(props.name)

const onBlur = () => autosave && submit()
</script>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>
